export default __webpack_public_path__ + "static/media/accounts-icon.72737e8a.svg";